import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getIDAQuestions, submitIDAAnswers, veridTimerExpired } from '../../actions';
import { getVeridData } from '../../selectors';
import Section from '../Section/section';
import VeridForm from './VeridForm/veridForm';
import CountDownTimer from './CountDownTimer/countDownTimer';
import PropTypes from 'prop-types';

const normalizeAnswers = (values) => {
  let result = {};
  Object.entries(values).forEach(([key, value]) => {
    let normalizedKey = key.split('-')[1]; // Drop `question-` from key like `question-12345`
    result[normalizedKey] = value;
  });
  return result;
};

export class VeridPage extends Component {

  componentDidMount = () => {
    this.props.getIDAQuestions();
  }

  handleSubmit = (values) => {
    const answers = normalizeAnswers(values);
    answers.transactionId = this.props.veridData.transactionId;
    answers.questionSetId = this.props.veridData.questions[0].questionSetId;
    this.props.submitIDAAnswers(answers);
  }

  handleTimerExpired = () => {
    this.props.veridTimerExpired();
  }

  render = () => {
    const content = this.props.veridData ?
      (<Section className="verid">
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-12 verid-timer">
              <CountDownTimer onCountDown={this.handleTimerExpired}/>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <h2>You must answer these questions before we can continue processing your loan.</h2>
            </div>
          </div>
        </div>
        <VeridForm onSubmit={this.handleSubmit} questions={this.props.veridData.questions}/>
      </Section>)
      : null;
    return content;
  }
}

const mapStateToProps = (state) => ({ veridData: getVeridData(state) });
const mapDispatchToProps = { getIDAQuestions, submitIDAAnswers, veridTimerExpired };

VeridPage.propTypes = {
  getIDAQuestions: PropTypes.func.isRequired,
  submitIDAAnswers: PropTypes.func.isRequired,
  veridTimerExpired: PropTypes.func.isRequired,
  veridData: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(VeridPage);

